export enum EResidencyUrls {
  RESIDENCY = 'residency',
  APPLICATION = 'application',
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
}
